import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Table, Input, Typography, Popconfirm, Card, Row, Col, Form } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { GET_DELETED_DOCUMENTS } from 'src/graphql';
import { useLazyQuery } from '@apollo/client';
import { IDocuments } from '../interfaces';
import { PrimaryButton } from './Buttons';
import { errorMessage, successMessage } from '../utils/Notifications';
import Paginate from "./Paginate";

const FormItem = Form.Item;
const { Title, Text } = Typography;

export type UserTableProps = {
    title?: string;
    roleId?: 'CLIENT' | 'ADMIN';
};

type FormData = {
    email: string;
};

function DocumentArchive({ title, roleId }: UserTableProps): JSX.Element {
    const [documents, setDocuments] = useState<IDocuments[]>([]);
    const [userEmail, setUserEmail] = useState("");
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [skip, setSkip] = useState(0);
    const [count, setCount] = useState(20);
    const [total, setTotal] = useState(0);
    const [fetchArchives, { loading, data }] = useLazyQuery(GET_DELETED_DOCUMENTS);

    const handleSubmit = (formData: FormData) => {
        const { email } = formData;
        setUserEmail(email);
        fetchArchives({ variables: { email, skip, count  } });
    }

    const handleNext = (from: number) => {
        setSkip(from);
        fetchArchives({ variables: { email: userEmail, skip: from, count } });
    }

    useEffect(() => {
        if (data?.getDeletedDocuments) {
            setDocuments(data.getDeletedDocuments?.documents);
            setTotal(data.getDeletedDocuments?.pagination?.total);
        }
    }, [data]);

    return (
        <>
            <div
                style={{
                    padding: '7px',
                    marginLeft: '5px',
                    marginRight: '5px',
                    background: '#ffffff',
                    borderRadius: '15px',
                }}
            >
                <Row>
                    <Col span="24" style={{ paddingLeft: '10px', paddingTop: '10px' }}>
                        <Text className="card-heading">{title}</Text>
                    </Col>
                    <Col span="24" style={{ marginTop: '-27px', paddingLeft: '10px' }}>
                        <Text style={{ fontWeight: 'bold', fontSize: '20px', color: '#EE773B' }}>___</Text>
                    </Col>
                </Row>

                <div
                style={{
                    padding: '7px',
                    marginLeft: '5px',
                    marginRight: '5px',
                    marginBottom: '10px',
                    background: '#ffffff',
                    borderRadius: '15px',
                }}
            >
                <Card className="card-no-padding">
                   
                     <Form className="margin-y-xl" onFinish={handleSubmit}>
                        <Row>
                            <Col
                                xs={{ span: 24 }}
                                sm={{ span: 24 }}
                                md={{ span: 6 }}
                                lg={{ span: 6 }}
                                className="padding-right-sm" style={{paddingTop:"10px", textAlign:"center"}}
                            >
                                <Title level={4} style={{color: "#0b543e", fontSize: "17px", marginTop: "5px"}}>Search by user email</Title>
                            </Col>
                            <Col
                                xs={{ span: 24 }}
                                sm={{ span: 24 }}
                                md={{ span: 6 }}
                                lg={{ span: 6 }}
                                className="padding-right-sm"
                                style={{padding:"5px"}}
                            >
                                <FormItem
                                    name="email"
                                    rules={[
                                        { required: true, message: 'Email is required' },
                                        { type: 'email', message: 'The input is not valid E-mail!' },
                                    ]}
                                >
                                    <Input name="email" placeholder="Email" type="email" style={{ borderWidth: '1px', borderColor: '#EE773B', borderRadius: '50px', height: '40px' }} />
                                </FormItem>
                            </Col>
                
                            <Col
                                xs={{ span: 24 }}
                                sm={{ span: 24 }}
                                md={{ span: 6 }}
                                lg={{ span: 6 }}
                                className="padding-left-lg"
                                style={{paddingTop: "20px", padding:"5px"}}
                            >
                                <PrimaryButton title="Search" htmlType="submit" loading={loading} />
                            </Col>
                         </Row>
                     </Form>
                   
                </Card>
             </div>

            <Card loading={loading}>
                    <table width="100%">
                      <thead>
                        <th style={{width: "30%", textAlign: "left"}}>Document Type</th>
                        <th style={{width: "35%", textAlign: "left"}}>Received On</th>
                        <th style={{width: "10%", textAlign: "left"}}>Actions</th>
                      </thead>
                      <tbody>
                        {
                         documents.length>0 &&  documents.map((document) => {
                         return(
                         <tr style={{height: "30px"}} key={document.id}>
                          <td style={{fontSize: "17px"}}>{document.type}</td>
                          <td style={{fontSize: "17px"}}>{document.receivedOn}</td>
                          <td>
                            <div className="display-flex">
                                <a href={document.url} download className="hoverable-icon black">
                                    <DownloadOutlined style={{ fontSize: '16px' }} />
                                </a>
                            </div>
                          </td>
                        </tr>
                         )
                        })
                       }
                      </tbody>
                    </table>
                
                </Card>
                <Card>
                  {
                    documents.length>0 &&  <Paginate
                    pageCount={(total/count)}
                    getRecords={handleNext}
                    />  
                   }
               </Card>
          </div>
        </>
    );
}

export default DocumentArchive;
